// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"Other_outdoor-recreation-F__0KxM1"};